// ── Строка карточки в списке плеера ──────────────────────────────────────────

import { memo, useRef, useState } from "react";
import { t } from "../../i18n";
import { FONT, SANS, cardColorIn } from "../../themes";
import { IconButton as UiIconButton, usePalette } from "../../ui";
import { fmt } from "../../utils";

// ── CardRow — строка карточки в плейлисте плеера ─────────────────────────────
// Скрытый перевод (expand по клику), long press → режим выбора нескольких.
export function CardRowView({c,i,total,selectMode,isSel,isActive,isLooped,onSelect,onEdit,onDelete,onLongPress,onSeek,onLoop}){
  const P=usePalette();
  const [expanded,setExpanded]=useState(false);
  const longPressTimer=useRef(null);
  const handleTouchStart=()=>{longPressTimer.current=setTimeout(()=>{onLongPress?.();},600);};
  const handleTouchEnd=()=>clearTimeout(longPressTimer.current);
  const handleClick=()=>{ if(selectMode){onSelect();return;} setExpanded(v=>!v); };
  const long=String(c.word||"").length>80;
  return(
    <div className="ac-row" data-card-id={c.id} onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} onTouchMove={()=>clearTimeout(longPressTimer.current)}>
      <div style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",cursor:"pointer",
          borderBottom:i<total-1?`1px solid ${P.border}`:"none",
          background:isActive?`${P.blue}22`:isSel?`${P.blue}18`:"transparent",
          borderLeft:isActive?`3px solid ${P.blue}`:"3px solid transparent",
          transition:"background .15s",
          paddingRight:"calc(14px + var(--ssi, 0px) * 0.5)"}}
        onMouseEnter={e=>{if(!isSel&&!isActive)e.currentTarget.style.background=P.trackActive;}}
        onMouseLeave={e=>{if(!isSel&&!isActive)e.currentTarget.style.background="transparent";}}>
        {selectMode?(
          <button type="button" role="checkbox" aria-checked={isSel} aria-label={t("Выбрать карточку {0}",[c.word])} onClick={onSelect}
            style={{width:32,height:36,margin:"-9px -7px",padding:0,background:"none",border:"none",flexShrink:0,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer"}}>
            <span style={{width:18,height:18,boxSizing:"border-box",borderRadius:12,border:`2px solid ${isSel?P.blue:P.border}`,background:isSel?P.blue:"transparent",display:"flex",alignItems:"center",justifyContent:"center"}}>
              {isSel&&<span style={{color:"#fff",fontSize:10,fontWeight:700}}>✓</span>}
            </span>
          </button>
        ):(
          <div style={{width:2,height:28,background:cardColorIn(P,c.color),borderRadius:1,flexShrink:0}}/>
        )}
        {/* Timecode — click seeks audio */}
        <button type="button" onClick={e=>{e.stopPropagation();onSeek&&onSeek(c.time_sec);}}
          title={t("Перемотать к этому моменту")} aria-label={t("Перемотать к {0}",[fmt(c.time_sec)])}
          style={{fontSize:11,color:P.blue,minWidth:36,minHeight:36,fontVariantNumeric:"tabular-nums",cursor:"pointer",fontWeight:600,flexShrink:0,lineHeight:1.3,
            background:"none",border:"none",padding:"0 2px",margin:"-11px -2px",textAlign:"left",fontFamily:SANS,boxSizing:"content-box"}}>
          {fmt(c.time_sec)}
        </button>
        {/* Text — click expands translation */}
        {/* Текст карточки тянется на всю высоту строки: короткое слово без перевода тоже
            нажимается во всю строку, а не полоской 22 px. */}
        <div onClick={handleClick} style={{flex:1,minWidth:0,alignSelf:"stretch",minHeight:36,display:"flex",flexDirection:"column",justifyContent:"center",cursor:"pointer"}}>
          {/* Длинная карточка (целый абзац) — три строки, по нажатию целиком: иначе на телефоне она тянется узкой колонкой на экраны. */}
          <div style={{fontFamily:FONT,fontSize:long?15:16,color:P.text,lineHeight:1.35,wordBreak:"break-word",
            ...(long&&!expanded?{display:"-webkit-box",WebkitLineClamp:3,WebkitBoxOrient:"vertical",overflow:"hidden"}:{})}}>{c.word}</div>
          {expanded&&c.translation&&<div style={{fontSize:12.5,color:P.mid,marginTop:3,lineHeight:1.4}}>{c.translation}</div>}
          {!expanded&&(c.translation||long)&&<div style={{fontSize:12,color:P.faint,marginTop:2}}>{c.translation?t("перевод ▾"):t("показать полностью ▾")}</div>}
        </div>
        {!selectMode&&(
          <div className="ac-row-actions" style={{display:"flex",gap:2,flexShrink:0,opacity:isLooped?1:undefined}}>
            <UiIconButton C={P} icon="loop" iconSize={15} size={32} variant={isLooped?"filled":"ghost"} label={isLooped?t("Остановить цикл"):t("Зациклить эту карточку")}
              onClick={e=>{e.stopPropagation();onLoop&&onLoop(c);}}/>
            <UiIconButton C={P} icon="edit" iconSize={15} size={32} variant="ghost" label={t("Редактировать")} onClick={e=>{e.stopPropagation();onEdit();}}/>
            <UiIconButton C={P} icon="trash" iconSize={15} size={32} variant="ghost" label={t("Удалить")} className="ac-danger" style={{color:P.faint}}
              onClick={e=>{e.stopPropagation();onDelete();}}/>
          </div>
        )}
      </div>
    </div>
  );
}
// Строка перерисовывается только когда меняются её данные или тема — не на каждый тик
// времени (в проекте на 264 карточки это и давало «лаги»). Обработчики строк берут
// свежие функции плеера через ref, поэтому их можно не сравнивать.
export const CardRow=memo(CardRowView,(a,b)=>a.c===b.c&&a.i===b.i&&a.total===b.total&&a.selectMode===b.selectMode
  &&a.isSel===b.isSel&&a.isActive===b.isActive&&a.isLooped===b.isLooped&&a.pal===b.pal);
